import { useEffect } from 'react';
import { useSchemaMicrodata, useMultipleSchemaMicrodata } from '../hooks/useSchemaMicrodata';
import { setPageTitle } from '../utils/pageTitle';

export default function SEO({
  title,
  description,
  pageTitle,
  schemaData,
  multipleSchemas,
  canonicalUrl,
  keywords = [],
  ogImage,
  ogType = 'website'
}) {
  // Set page title
  useEffect(() => {
    if (pageTitle) {
      setPageTitle(pageTitle);
    }
  }, [pageTitle]);

  // Set meta description
  useEffect(() => {
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = description;
    }
  }, [description]);

  // Set Open Graph tags
  useEffect(() => {
    if (title) {
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.content = title;
    }

    if (description) {
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.content = description;
    }

    if (ogImage) {
      let ogImageMeta = document.querySelector('meta[property="og:image"]');
      if (!ogImageMeta) {
        ogImageMeta = document.createElement('meta');
        ogImageMeta.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageMeta);
      }
      ogImageMeta.content = ogImage;
    }

    let ogTypeMeta = document.querySelector('meta[property="og:type"]');
    if (!ogTypeMeta) {
      ogTypeMeta = document.createElement('meta');
      ogTypeMeta.setAttribute('property', 'og:type');
      document.head.appendChild(ogTypeMeta);
    }
    ogTypeMeta.content = ogType;
  }, [title, description, ogImage, ogType]);

  // Set canonical URL
  useEffect(() => {
    if (canonicalUrl) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = canonicalUrl;
    }
  }, [canonicalUrl]);

  // Set keywords
  useEffect(() => {
    if (keywords.length > 0) {
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (!keywordsMeta) {
        keywordsMeta = document.createElement('meta');
        keywordsMeta.name = 'keywords';
        document.head.appendChild(keywordsMeta);
      }
      if(typeof keywords ==  'string') {
         keywordsMeta.content = keywords
      }else if(typeof keywords ==  'object') {
         keywordsMeta.content = keywords.join(',')
      }else {
        keywordsMeta.content = ''
      }
    }
  }, [keywords]);

  // Handle schema microdata - hooks must be called unconditionally
  useMultipleSchemaMicrodata(multipleSchemas || null);
  useSchemaMicrodata(
    schemaData?.type || null, 
    schemaData?.data || null
  );

  return null; // This component doesn't render anything
} 